import React, { useContext } from 'react';
import Item from '../Shared/Item';
import { CardsReward_context } from '../context';

const GridMode = ({ rewards }) => {
  const { gridExpander } = useContext(CardsReward_context);
  if (rewards === undefined || rewards === null) {
    return null;
  }
  return (
    <div className="crgv__grid-mode-items flex-it flex-wrap">
      {rewards?.map((item, index) => {
        return <Item key={index} index={index} item={item} />;
      })}
      <div className="crgv__grid-expander" ref={gridExpander}></div>
    </div>
  );
};

export default GridMode;
